// Per-service galleries. Balayage uses the dedicated uploaded set; the others
// reuse existing site photos for now and can be swapped with dedicated archives.

const img = (src, title) => ({ src, alt: `${title} — LadyArt Fălticeni` });

const balayageImages = Array.from({ length: 10 }, (_, i) =>
    img(`/photos/gallery/balayage/${i + 1}.webp`, "Balayage"),
);

export const GALLERIES = {
    airtouch: {
        slug: "airtouch",
        eyebrow: "Portofoliu · Serviciu",
        title: "AirTouch",
        intro: "Tranziții fine de culoare, construite fir cu fir pentru un rezultat natural și luminos.",
        images: Array.from({ length: 5 }, (_, i) =>
            img(`/photos/gallery/airtouch/${i + 1}.webp`, "AirTouch"),
        ),
    },
    balayage: {
        slug: "balayage",
        eyebrow: "Portofoliu · Serviciu",
        title: "Balayage",
        intro: "Reflexii pictate manual, cu profunzime și dimensiune naturală. O selecție de lucrări realizate în salon.",
        images: balayageImages,
    },
    "corectie-culoare": {
        slug: "corectie-culoare",
        eyebrow: "Portofoliu · Serviciu",
        title: "Corecție de culoare",
        intro: "Echilibrăm nuanța și redăm armonia culorii, cu grijă pentru sănătatea firului.",
        images: [],
    },
    styling: {
        slug: "styling",
        eyebrow: "Portofoliu · Serviciu",
        title: "Styling",
        intro: "Coafuri de eveniment și volum editorial, finisate pentru viața reală.",
        images: Array.from({ length: 9 }, (_, i) =>
            img(`/photos/gallery/styling/${i + 1}.webp`, "Styling"),
        ),
    },
};

// Map each service card (by title) to its gallery slug.
export const SERVICE_SLUG = {
    AirTouch: "airtouch",
    Balayage: "balayage",
    "Corecție de culoare": "corectie-culoare",
    Styling: "styling",
};
